<template>
  <div :class="$style.inputRow">
    <InputOptionalValidation
      :class="$style.half"
      :disabled="true"
      :label="'Directory Type'"
      :name="'external_source_type'"
      :type="'text'"
      :value="parent.external_source_type"
    />
    <InputOptionalValidation
      :class="$style.half"
      :disabled="true"
      :label="'Domain'"
      :name="'external_dn'"
      :type="'text'"
      :value="parent.external_dn"
    />
  </div>
</template>
<script>
import AsidePanelChildComponentMethodsMixin from 'client/components/AsidePanel/mixins/AsidePanelChildComponentMethodsMixin';
import AsidePanelChildComponentPropsMixin from 'client/components/AsidePanel/mixins/AsidePanelChildComponentPropsMixin';
import InputOptionalValidation from 'client/components/FormValidation/Input.vue';

export default {
  name: 'ExternalManagementDetails',

  inject: ['$validator'],

  components: {
    InputOptionalValidation,
  },

  mixins: [
    AsidePanelChildComponentMethodsMixin,
    AsidePanelChildComponentPropsMixin,
  ],

  computed: {},

  beforeCreate() {
    this.$options.methods.asidePanelChildComponentHandleBeforeCreate(this.$options, true);
  },

  methods: {},
};
</script>
<style module>
@import '../../css/flex.css';
@import '../../components/FormValidation/css/formFields.css';
</style>
